import { api } from './client';

/** ч.793: рядок реєстру непроведених документів. */
export interface UnpostedRow {
  document_type: string;
  document_id: string;
  organization_id: string;
  organization_name: string | null;
  date: string | null;
  number: string | null;
  amount: number | null;
  contractor_name: string | null;
}

export interface UnpostedPage {
  types: string[];
  catalog: { group: string; types: string[] }[];
  items: UnpostedRow[];
  total: number;
  limit: number;
  offset: number;
}

export const postingMonitor = {
  unposted: (params: {
    organization_id?: string; document_type?: string;
    date_from?: string; date_to?: string; include_migrated?: boolean;
    sort_by?: string; sort_dir?: 'asc' | 'desc'; limit?: number; offset?: number;
  }) => api.get<UnpostedPage>('/posting-monitor/unposted', { params }).then((r) => r.data),
};
